module.exports = __webpack_public_path__ + "img/downloadIcon.c509e0ee.svg";